import { render } from "./SettingsGeneralPage.vue?vue&type=template&id=13108eda"
import script from "./SettingsGeneralPage.vue?vue&type=script&lang=js"
export * from "./SettingsGeneralPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__